import React from 'react'
import { SearchPartyStore } from '@App/stores/search/party/search-party-store'
import { HasSearchCriteria } from '@App/stores/search/helpers/has-search-criteria'
import { SearchResultPartyDetails } from '@Entities/party-details'
import SearchByParty from '@Components/Search/SearchByParty'
import PartyResultsTable from '@Components/Search/SearchByParty/PartyResultsTable'
import SearchResultPartyDetailsCard from '@Components/Search/SearchByParty/SearchResultPartyDetailsCard'
import { SelectedPublisher } from '@App/stores/rightsholder/catalogTransfer/catalog-transfer-wizard-store'
import MultiplePublisherSelectorDetailCard from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/MultiplePublisherSelector/MultiplePublisherSelectorDetailCard'
import TransferSelectionPanel from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/MultiplePublisherSelector/TransferSelectionPanel'
import './index.scss'

interface MultiplePublisherSelectorProps {
    store: SearchPartyStore<SearchResultPartyDetails> & HasSearchCriteria<Record<string, never>>
    selectedPublishers: SelectedPublisher[]
    onAddPublisher: (publisher: SelectedPublisher) => void
    onRemovePublisher: (ipId: string) => void
    isPublisherSelected: (ipId?: string | null) => boolean
}

const MultiplePublisherSelector = ({
    store,
    selectedPublishers,
    onAddPublisher,
    onRemovePublisher,
    isPublisherSelected,
}: MultiplePublisherSelectorProps) => {
    const handleTogglePublisher = (publisher: SearchResultPartyDetails) => {
        if (!publisher.ipId) {
            return
        }
        if (isPublisherSelected(publisher.ipId)) {
            onRemovePublisher(publisher.ipId)
            return
        }
        onAddPublisher({
            ipId: publisher.ipId,
            name: publisher.name,
            worksCount: publisher.worksCount ?? 0,
            hfaPublisherNumber: publisher.hfaPublisherNumber,
        })
    }

    return (
        <div className="multiple-publisher-selector">
            <div className="publisher-search-panel">
                <SearchByParty
                    searchPartyStore={store}
                    partyDetailsCardComponent={SearchResultPartyDetailsCard}
                    renderPartyResultsTable={(onTitleClick, setLoading) => (
                        <PartyResultsTable
                            searchPartyStore={store}
                            setLoading={setLoading}
                            onTitleClick={onTitleClick}
                            PartyDetailsCardComponent={({ partyDetails }) => (
                                <MultiplePublisherSelectorDetailCard
                                    partyDetails={partyDetails}
                                    onTitleClick={onTitleClick}
                                    isSelected={isPublisherSelected(partyDetails.ipId)}
                                    onToggle={() => handleTogglePublisher(partyDetails)}
                                />
                            )}
                        />
                    )}
                />
            </div>
            <TransferSelectionPanel selectedPublishers={selectedPublishers} onRemovePublisher={onRemovePublisher} />
        </div>
    )
}

export default MultiplePublisherSelector
